'use client';

import { useState } from 'react';
import { countryCodeToFlagUrl } from '@/lib/flag-utils';

interface FlagProps {
  code: string;
  size?: number;
  className?: string;
  countryName?: string;
}

export function Flag({ code, size = 20, className, countryName }: FlagProps) {
  const [error, setError] = useState(false);
  const src = countryCodeToFlagUrl(code);

  if (!src || error) {
    return (
      <span
        className={className}
        aria-label={code}
        style={{
          display: 'inline-block',
          verticalAlign: 'middle',
          width: size,
          height: size,
          lineHeight: `${size}px`,
          textAlign: 'center',
          fontSize: size * 0.6,
          fontWeight: 600,
          color: 'var(--color-text-secondary)',
        }}
      >
        {code?.toUpperCase() || '??'}
      </span>
    );
  }

  const altText = countryName ? `Flag of ${countryName}` : code;

  return (
    <img
      src={src}
      alt={altText}
      width={size}
      height={size}
      loading="lazy"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      onError={() => setError(true)}
    />
  );
}
